<template>
	<el-main class="portal-ai">
		<Banner />
    	<EduIntro />
	</el-main>
</template>

<script>
	import Banner from './AiEduBanner'
  	import EduIntro from './EduIntro'
	export default {
		name: 'PortaEdu',
		components: {
			Banner,
			EduIntro,
		},
		data() {
			return {}
		}
	}
</script>

<style>
	.rect-bg {
		position: absolute;
		left: 0;
		float: left;
		width: calc(100vw - 17px);
		min-width: 1200px;
		height: 2549px;
		-webkit-clip-path: polygon(45% 0, 100% 0, 36% 100%, 0 100%);
		clip-path: polygon(45% 0, 100% 0, 36% 100%, 0 100%);
		background: rgba(255,255,255,.3);
	}
  .portal-ai {
    position: relative; background-color: rgba(234,242,249,.22);
    overflow-y: hidden;
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/PortalEdu.vue